import moment from "moment";
import React, { useEffect, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "react-pro-sidebar/dist/css/styles.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useUser } from "../../../redux/reducers/AuthReducer";
import {
  useAccruedData,
  useSkills,
  useTasks,
  useSuccess as monthlyDocSuccess,
} from "../../../redux/reducers/MonthlyDocReducer";
import {
  setShowSidebar,
  useShowSidebar,
} from "../../../redux/reducers/SidebarReducer";
import {
  useData,
  useIsLoading,
  useSuccess,
} from "../../../redux/reducers/TraineesReducer";
import {
  fetchAccrued,
  fetchAccruedByDate,
} from "../../../redux/sagas/monthlyDocument/fetchAccruedSaga";
import { fetchSkills } from "../../../redux/sagas/monthlyDocument/fetchSkillsSaga";
import { fetchTasks } from "../../../redux/sagas/monthlyDocument/fetchTasksSaga";
import { submitDocument } from "../../../redux/sagas/monthlyDocument/submitDocSaga";
import { fetchAllTrainees } from "../../../redux/sagas/trainees/fetchAllSaga";
import { calculateWeeks, useDispatchEffect } from "../../../utils/hooks";
import "./styles.scss";

import { fetchAll } from "../../../redux/sagas/experienceLog/fetchAllSaga";
import { fetchDoc } from "../../../redux/sagas/monthlyDocument/fetchDocSaga";
import {
  LABELS,
  LOG_DATA,
  TASK_LIST_GRID_LEGEND_HELP,
  TASKS_TABLE,
  TASKS_TABLE_SIXTH_EDITION,
} from "../../../utils/CONSTANTS";
import Tooltip from "../../../components/Tooltip";
import { FaEye } from "react-icons/fa";
import { BiCalendar } from "react-icons/bi";
import { useDocs } from "../../../redux/reducers/MonthlyDocReducer";
import { Link, useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import { useRef } from "react";
import {
  useFlagged,
  useFormData,
  useIsExpLoading,
  useLogs,
  usePastFlagged,
} from "../../../redux/reducers/ExpLogReducer";
import { useIsV6 } from "../../../redux/reducers/AppStateReducer";
import GridInformation from "../../../components/GridInformation/GridInformation";

const NUMBER_TASKS = [
  {
    id: "0",
    value: 0,
    color: "#EEEEEE",
  },
  {
    id: "1",
    value: 1,
    color: "var(--color-light)",
  },
  {
    id: "2",
    value: 2,
    color: "#F4EEB6",
  },
  {
    id: "3",
    value: 3,
    color: "#E8EDBD",
  },
  {
    id: "4",
    value: 4,
    color: "#DDECC4",
  },
  {
    id: "5",
    value: 5,
    color: "#D1EBCA",
  },
  {
    id: "6",
    value: 6,
    color: "#C5EBD1",
  },
  {
    id: "7",
    value: 7,
    color: "#B9EAD7",
  },
  {
    id: "8",
    value: 8,
    color: "#AEE9DE",
  },
  {
    id: "9+",
    value: 9,
    color: "#A1E8E4",
  },
];

const NUMBER_TASKS2 = [
  {
    id: "0 - 3",
    value: 1,
    textColor: 'black',
    color: "var(--color-warning)",
  },
  {
    id: "3 - 6",
    value: 2,
    textColor: 'white',
    color: "var(--color-info)",
  },
  {
    id: "6 - 10",
    value: 3,
    textColor: 'white',
    color: "var(--color-primary)",
  },
];

const MonthlyDocument = () => {
  const navigate = useNavigate();
  const showSidebar = useShowSidebar();
  const dispatch = useDispatch();
  const trainees = useData();
  const success = useSuccess();
  const isLoading = useIsLoading();
  const isV6 = useIsV6();

  const [date, setDate] = useState(new Date());
  
  const [isChecked, setIsChecked] = useState(false);
  const logs = useLogs();
  const tasks = {};
  let total_restricted_hrs = 0;
  let total_unrestricted_hrs = 0;
  let total_supervisor_hrs = 0;

  const [trainee, setTrainee] = useState();

  useDispatchEffect(fetchAllTrainees, null, true);

  useEffect(() => {
    if (success) setTrainee(trainees[0]?.id);
  }, [success]);

  for (const log of logs) {
    if (log.user.id != trainee) {
      continue;
    }
    const taskCodes = log.task?.map((t) => t.name.split(" ")[0]);
    let check = moment(log.date_of_experience).isSame(date, "month");
    if (isChecked) {
      if (check) {
        for (const taskCode of taskCodes) {
          if (taskCode) {
            if (tasks[taskCode] && Array.isArray(tasks[taskCode]))
              tasks[taskCode].push(log?.date_of_experience);
            else tasks[taskCode] = [log?.date_of_experience];
          }
        }
        total_restricted_hrs += Number(log?.restricted_hours);
        total_unrestricted_hrs += Number(log?.unrestricted_hours);
      }
    } else {
      for (const taskCode of taskCodes) {
        if (taskCode) {
          if (tasks[taskCode] && Array.isArray(tasks[taskCode]))
            tasks[taskCode].push(log?.date_of_experience);
          else tasks[taskCode] = [log?.date_of_experience];
        }
      }
      total_restricted_hrs += Number(log?.restricted_hours);
      total_unrestricted_hrs += Number(log?.unrestricted_hours);
    }
  }

  const [week, setWeek] = useState(0);

  const weeks = calculateWeeks(date);

  const onPrevMonth = () => {
    const newDate = moment(date).subtract(1, "month");
    setDate(newDate.toDate());
  };
  const onNextMonth = () => {
    const newDate = moment(date).add(1, "month");
    setDate(newDate.toDate());
  };
  const onWeekChange = (weekNo) => {
    setWeek(weekNo);
  };

  const toogleButton = () => {
    if (isChecked) {
      return (
        <div onClick={handleOnChange}>
          <FaEye /> View Overall
        </div>
      );
    } else {
      return (
        <div onClick={handleOnChange}>
          <BiCalendar /> View Monthly
        </div>
      );
    }
  };

  const callbackFunction = (childData) => {
    setDate(childData);

    // Refresh experience log after date update
    if (isChecked) {
      refreshData(!isChecked, childData);
    }
  };

  const renderTaskColor = (task) => {
    const taskDates = tasks[task];
    if (taskDates?.length > 0 && taskDates?.length <= 3) return "var(--color-warning)";
    else if (taskDates?.length > 3 && taskDates?.length <= 6) return "var(--color-info)";
    else if (taskDates?.length > 6 && taskDates?.length <= 10) return "var(--color-primary)";
    else return "var(--color-white)";
  };

  const renderTaskDates = (task) => {
    var taskDates = tasks[task];
    console.log(tasks);
    if (!taskDates) {
      return <li>
        <em>Task not completed</em>
      </li>
    }
    taskDates = taskDates.sort();
    return taskDates.map((i) => {
      var date = "mm/dd/yyyy";
      var splitDate = i.split("-");
      if (splitDate[1].startsWith("0")) {
        splitDate[1] = splitDate[1].substring(1);
      }
      if (splitDate[2].startsWith("0")) {
        splitDate[2] = splitDate[2].substring(1);
      }
      date = splitDate[1] + "/" + splitDate[2] + "/" + splitDate[0];
      const disabled = date === "mm/dd/yyyy";
      return (
        <li key={task + i}>
          {date}
        </li>
      );
    });
  };

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const onRefreshData = useDispatchEffect(fetchAll, null, true);

  // Triggers dispatch effect with date param ('MM-YYYY') or null for overall
  const refreshData = (isOverall, date = null) => {
    if (isOverall) {
      onRefreshData()
    } else {
      const params = moment(date).format('MM-YYYY')
      onRefreshData(params)
    }
  }

  if (isLoading) return <LoadingSpinner style={{ width: "100%" }} />;

  return (
    <div className="section monthly-document" style={{ overflowX: "auto" }}>
      <div className="columns">
        <div className="column is-one-fifths">
          <button
            className="Toggle_btn"
            onClick={() => dispatch(setShowSidebar(!showSidebar))}
          >
            {showSidebar ? <GiHamburgerMenu /> : <GiHamburgerMenu />}
          </button>
          <p className="headingMain">
            {isV6 ? "Test Content Outline" : "Task List"} Grid
          </p>
          <label className="label">Student Name</label>
          <select
            className="select dropdownCustom is-normal"
            value={trainee}
            onChange={(e) => setTrainee(e.target.value)}
          >
            {trainees.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="section2">
        <div className="columns">
          <div className="column">
            <div className="grid-top mb-2" style={{ alignItems: "center" }}>
              <div className="calendar-header">
                <div>
                  <div className="topping">{toogleButton()}</div>
                </div>
                <p className="headingMain mt30" style={{ marginLeft: "12px" }}>
                  <button
                    className="backlink"
                    onClick={onPrevMonth}
                    disabled={!isChecked}
                  >
                    <IoIosArrowBack
                      size={24}
                      style={{ margin: "0 20px", marginLeft: 0 }}
                    />
                  </button>
                  <select
                    className="select selectBtn dropdownCustom2  is-normal"
                    style={{ height: "28px" }}
                    value={week}
                    onChange={(e) => onWeekChange(e.target.value)}
                  >
                    {weeks.map((week, index) => (
                      <option key={index} value={index}>
                        {isChecked
                          ? `${moment()
                              .month(date.getMonth())
                              .format("MMMM")}  ${date.getFullYear()}`
                          : "Overall Progress"}
                      </option>
                    ))}
                  </select>
                  <button
                    className=" backlink"
                    onClick={onNextMonth}
                    style={{ margin: "0 20px" }}
                    disabled={!isChecked}
                  >
                    <IoIosArrowForward size={24} style={{ margin: "0 20px" }} />
                  </button>
                </p>
                <div className="grid-top mt30">
                  <div>
                    <div
                      style={{
                        float: "left",
                        position: "relative",
                        top: "-5px",
                        left: "-5px",
                      }}
                    >
                      <Tooltip content={TASK_LIST_GRID_LEGEND_HELP} />
                    </div>
                    <div className="color-scale">
                      {NUMBER_TASKS2.map((i) => {
                        return (
                          <div
                            className="pill"
                            style={{
                              backgroundColor: i.color,
                              color: i.textColor,
                            }}
                            key={i.id}
                          >
                            {i.id}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="columns">
                <div className="column is-four-fifths monthlyTableMove">
                  <table style={{ border: "none" }}>
                    <tbody className="monthlyTable" style={{ border: "none" }}>
                      {(isV6 ? TASKS_TABLE_SIXTH_EDITION : TASKS_TABLE).map(
                        (row, i) => (
                          <tr key={"row-" + i}>
                            {row.map((cell, j) => (
                              <td
                                key={`cell-${i}${j}`}
                                className={j === 2 ? "customColumn" : ""}
                              >
                                {cell && (
                                  <div
                                    style={{
                                      background: renderTaskColor(cell.id),
                                      border: "none",
                                    }}
                                    className="selectBtn dropdownCustom mt is-normal"
                                  >
                                    {cell.id.replace(isV6 ? "." : "-", "")}
                                    <div>
                                      <p
                                        style={{
                                          background: renderTaskColor(cell.id),
                                          textAlign: "left",
                                          paddingTop: 10,
                                          paddingLeft: 10,
                                        }}
                                      >
                                        <span
                                          style={{
                                            display: "inline-block",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          {cell.description}
                                        </span>
                                        <br />
                                        <strong>Dates completed:</strong>
                                      </p>
                                      <ul
                                        style={{
                                          background: renderTaskColor(cell.id),
                                          textAlign: "left",
                                          padding: 10,
                                        }}
                                      >
                                        {renderTaskDates(cell.id)}
                                      </ul>
                                    </div>
                                  </div>
                                )}
                              </td>
                            ))}
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <p className="instruct supervisor">
              Select a task above to view specific logs
            </p>
            {isV6 && <GridInformation />}
          </div>
        </div>
      </div>
    </div>
  );
};

const AccruedTable = ({ title, data }) => {
  const {
    independent_hours,
    unrestricted_hours,
    percent_unrestricted,
    supervision_contacts,
    percent_supervision,
  } = data;

  return (
    <div>
      <table className="agenda-table">
        <tr className="barTableHeader">
          <th colSpan="2">{title}</th>
        </tr>
        <tr>
          <td>Independent Hours</td>
          <td className="colSize1">{independent_hours || "0"}</td>
        </tr>
        <tr>
          <td>Unrestricted Hours</td>
          <td className="colSize1">{unrestricted_hours || "0"}</td>
        </tr>
        <tr>
          <td>% Unrestricted</td>
          <td className="colSize1">{percent_unrestricted?.toFixed(0) || "0"}%</td>
        </tr>
        <tr>
          <td># Supervision Contacts</td>
          <td className="colSize1">{supervision_contacts?.toFixed(0) || "0"}</td>
        </tr>
        <tr>
          <td>% Supervision</td>
          <td className="colSize1">{percent_supervision?.toFixed(0) || "0"}%</td>
        </tr>
      </table>
    </div>
  );
};

const Task = ({ name, onChange }) => {
  const [task, setTask] = useState({
    name,
    canDemonstrate: false,
    canExplain: false,
    feedback: "",
    review: "",
  });
  const handleChange = (prop) => (e) => {
    const newTask = { ...task, [prop]: e.target.value };
    setTask(newTask);
  };
  const handleCheckChange = (prop) => (e) => {
    const newTask = { ...task, [prop]: e.target.checked };
    setTask(newTask);
    onChange(newTask);
  };

  return (
    <tr>
      <td style={{ width: "30%", textAlign: "left", paddingLeft: "16px" }}>
        {name || ""}
      </td>
      <td style={{ width: "10%" }}>
        <input
          type="checkbox"
          className=""
          value={task.canDemonstrate || false}
          onChange={handleCheckChange("canDemonstrate")}
        />
      </td>
      <td style={{ width: "10%" }}>
        <input
          type="checkbox"
          className=""
          value={task.canExplain || false}
          onChange={handleCheckChange("canExplain")}
        />
      </td>
      <td style={{ width: "20%" }}>
        <input
          type="text"
          className="inputagenda3"
          value={task.feedback || ""}
          onChange={handleChange("feedback")}
          onBlur={() => onChange(task)}
        />
      </td>
      <td style={{ width: "20%" }}>
        <input
          type="text"
          className="inputagenda3"
          value={task.review || ""}
          onChange={handleChange("review")}
          onBlur={() => onChange(task)}
        />
      </td>
    </tr>
  );
};
export default MonthlyDocument;
